import React from 'react';
import type { GridProps } from '../../components/grid';
import { Grid } from '../../components/grid';
import { Box, SkeletonGroup } from '@wix/design-system';
import { AppBoxSkeleton } from '../../components/app-box/app-box-skeleton';
import type { AppBoxSkin } from '../../components/app-box/app-box.types';

export interface AppGridSkeletonProps {
  boxCount: number;
  columns?: GridProps['columns'];
  minColumns?: GridProps['minColumns'];
  rows?: GridProps['rows'];
  dataHook?: string;
  skin?: AppBoxSkin;
}

export function AppGridSkeleton({
  boxCount,
  columns = 4,
  minColumns,
  rows,
  dataHook,
  skin = 'default',
}: AppGridSkeletonProps) {
  return (
    <Box width="100%" direction="vertical">
      <Grid
        dataHook={dataHook ?? 'app-grid-skeleton'}
        columns={columns}
        minColumns={minColumns}
        rows={rows}
        skin={skin}
      >
        {Array.from({ length: boxCount }).map((_value, index) => (
          <SkeletonGroup key={index}>
            <AppBoxSkeleton skin={skin} />
          </SkeletonGroup>
        ))}
      </Grid>
    </Box>
  );
}
